import { DashboardState } from './modules/dashboard/state/state';
import { ReportingState } from './modules/reporting/state/state';
import { ObjectsManagerState } from './modules/settings/objects-manager/state/state';
import { AccountState } from './state/account/state';
import { UserState } from './state/user/state';
import { FieldDefsState } from './state/fields/state';
import { FolderResourceState } from './shared/modules/folders/state/state';
import { NotesState } from './shared/modules/notes/state/state';
import { TaskRolesState } from './modules/settings/task-roles/state/state';
import { SettingsRolesPermissionState } from './modules/settings/roles-permissions/state/state';
import { AutomationState } from './modules/settings/automations/state/state';
import { JobsStatusState } from './modules/settings/jobs-status/state/state';
import { ResearchState } from './modules/research/state/state';
import { EthanState } from './state/ethan/ethan.state';
import { FolderTemplatesState } from './modules/settings/folder-templates/state/state';

export const AppStates = [
  AccountState,
  ReportingState,
  ObjectsManagerState,
  DashboardState,
  FieldDefsState,
  FolderResourceState,
  NotesState,
  TaskRolesState,
  SettingsRolesPermissionState,
  UserState,
  AutomationState,
  JobsStatusState,
  ResearchState,
  EthanState,
  FolderTemplatesState,
];
